import React, { useEffect, useState } from 'react';
import aceptadas from '../assets/aceptadas.png';
import enviadas from '../assets/enviadas.png';
import flechaSelect from '../assets/flechaSelect.png';
import noConcretadas from '../assets/noConcretadas.png';
import recibidas from '../assets/recibidas.png';
import axios from '../axiosConfig';
import '../css/navBar.css';
import { handleError, toastError, toastSuccess } from '../funciones';
import DeseaCancelar from './DeseaCancelar';
import Imprimir from './Imprimir';
import Modal from './Modal';
import ModalPerfil from './ModalPerfil';
import Paginacion from './Paginacion';
import { LoaderTabla } from './LoaderTabla';


function TablaActividades() {

    const [cantPaginas, setCantPaginas] = useState(1);
    const [cantPaginasCopia, setCantPaginasCopia] = useState(1);
    const [paginaActual, setPaginaActual] = useState([]);
    const [eventoActual, setEventoActual] = useState({
        nombreEvento: "", empresasDeInteres: [],
        empresasInteresadas: [],
        reuniones: [], reunionesNoConcretadas: []
    });
    const [elementos, setElementos] = useState([]);
    const [elementosCopia, setElementosCopia] = useState([]);
    const [elementosTotal, setElementosTotal] = useState([]);
    const [cantidadElementos, setCantidadElementos] = useState([]);
    const [primeraCarga, setPrimeraCarga] = useState(true);
    const [pagActual, setPagActual] = useState(1);
    const [permitirElegirHorario, setPermitirElegirHorario] = useState(false);
    const [idsCancelada, setIdsCancelada] = useState([]);
    const [inscripcionModificar, setInscripcionModificar] = useState([]);
    const [perfil, setPerfil] = useState({ rubros: [], productosOfrecidos: [], nombre: '' });
    const [paramsCancReunion, setParamsCancReunion] = useState({ idReunion: -1, idEmpresa: -1 });
    const [loading, setLoading] = useState(true);
    //const [topActActual, setTopActActual]=useState(1); 

    var cantElementos;
    useEffect(() => {
        const tabla = document.getElementById("tabla");


        const altAct = 92;
        const cantElementos = (tabla.offsetHeight - 20) / altAct - 1;
        setCantidadElementos(cantElementos);
        let elemPagina = [];
        var contPaginas = 0;
        var params = {
            params: {
                empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }

        axios
            .get(process.env.REACT_APP_URL + 'empresa/allInformacionEmpresa', params)
            .then(function (response) {
                setElementosTotal(response.data);
                response.data.forEach(function (empresa, i) {
                    elemPagina.push(empresa);
                    if ((i + 1) % Math.floor(cantElementos) === 0) {
                        var objeto = elemPagina;
                        setElementos(elementos => [...elementos, objeto])
                        setElementosCopia(elementosCopia => [...elementosCopia, objeto]);
                        /*if(elemActFaltan){ 
                            setPaginaActual(objeto);
                            elemActFaltan = false;
                        }*/
                        elemPagina = [];
                        contPaginas++;
                    }

                });
                if (elemPagina.length !== 0) {
                    var objeto = elemPagina;
                    setElementos(elementos => [...elementos, objeto])
                    setElementosCopia(elementosCopia => [...elementosCopia, objeto]);
                    /*if(elemActFaltan){
                        setPaginaActual(objeto); 
                    }*/
                    contPaginas++;
                }
                if (contPaginas === 0)
                    contPaginas++;
                setCantPaginas(contPaginas);
                setCantPaginasCopia(contPaginas);
            })
            .catch(function (error) {
                toastError(handleError(error))
                //return toast.error("Error al cargar las redacciones, inténtelo más tarde");
            })
            .finally(() => {
                setLoading(false)
            });
    }, [])

    function cambiarPagina(numPagina) {
        const idAct = localStorage.getItem(process.env.REACT_APP_ID_ACTIVIDAD);
        if (idAct !== null && !primeraCarga) {
            mostrarActividad(idAct);

            new Promise(resolve => setTimeout(resolve, 1500)).then(() => {
                elementos.map(function (elem, i) {
                    if (i === numPagina - 1) {
                        setPaginaActual(elem);
                    }
                });
            }
            );
        }
        else {
            elementos.map(function (elem, i) {
                if (i === numPagina - 1) {
                    setPaginaActual(elem);
                    /*paginaActual.forEach(function(elem){ 
                        if(idAct !== elem.eventoId){
                            const elem2 = document.getElementById("idAct" + elem.eventoId);
                            elem2.classList.remove("ocultarActividad");
                        }
                    });
                    cambiarPagina(1)*/
                }
            });
        }
    }
    function modificarInscripcion(params) {

        const idInscripcion = params.id;

        var params = {
            params: {
                inscripcionId: idInscripcion
            }
        }
        axios
            .get(process.env.REACT_APP_URL + 'empresa/informacionEmpresa', params)
            .then(function (response) {
                setEventoActual(response.data)
                setElementosTotal(elementosTotal.map((elem) => {
                    if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem = response.data;
                    return elem;
                }));

                setPaginaActual(paginaActual.map((elem) => {
                    if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem = response.data;
                    return elem;
                }));


                setElementos(elementos.map((elem) => {
                    var ret = elem.map((elem2) => {
                        if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                            elem2 = response.data;
                        return elem2;
                    })
                    return ret;
                }));


                setElementosCopia(elementosCopia.map((elem) => {

                    var ret = elem.map((elem2) => {
                        if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                            elem2 = response.data;
                        return elem2;
                    })
                    return ret;
                }));
            })
            .catch(function (error) {

                toastError(handleError(error))
                //return toast.error("Error al cargar las redacciones, inténtelo más tarde");
            });
    }
    function cambiarEvento(idEvento) {
        paginaActual.map(function (elem) {
            if (elem.eventoId === idEvento) {
                setEventoActual(elem);
            }
        });
    }

    useEffect(() => {
        if (primeraCarga && elementos.length !== 0) {
            setPrimeraCarga(false);
            cambiarPagina(1);
        }
    }, [elementos])

    useEffect(() => {
        var positionTop = 0;
        paginaActual.forEach(function (elem, i) {

            /*if(i > 0){
                const altAct = document.getElementById("idAct" + cantElementos).offsetHeight;
                positionTop += altAnt; 
            }*/
            const elem2 = document.getElementById("idAct" + elem.eventoId);

            if (elem2) {
                if (window.screen.availWidth > 575)
                    elem2.style.top = "calc(" + (2 * i) + "rem + " + positionTop + "px)";
                else
                    elem2.style.top = "calc(" + (i * 1.5) + "rem + " + positionTop + "px)";
                positionTop += elem2.scrollHeight;
            }
            //altAct2= elem2.offsetHeight;(positionTop + altAct2) 

            //bottomAct = elem2.getBoundingClientRect().top + elem2.offsetHeight + 32;

        });
    }, [paginaActual])

    useEffect(() => {
        for (var i = 1; i <= 4; i++) {
            const reuniones = document.getElementById("reuniones" + i);
            /*var children = reuniones.childNodes;
            var alturaReunion = 0;
            for (var x = 0; x < children.length; x++) {
                alturaReunion += children[x].scrollHeight;
            }*/
            //console.log(reuniones.scrollHeight)
            //reuniones.style.height = alturaReunion + "px";
            if(reuniones)
            reuniones.style.height = reuniones.scrollHeight + "px";
        }
    }, [eventoActual])

    function mostrarActividad(idAct, idInscripcion, tieneReuniones) {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_ES_CANCELAR)) === 1) {
            seleccionarIscripcion(idInscripcion);
            localStorage.removeItem(process.env.REACT_APP_ES_CANCELAR);
        }
        else {
            if (tieneReuniones === undefined) {


                const descripcionAct = document.getElementById("descripcionAct");
                const elem = document.getElementById("idAct" + idAct);
                if (parseInt(localStorage.getItem(process.env.REACT_APP_ID_ACTIVIDAD)) !== -1) {

                    localStorage.setItem(process.env.REACT_APP_ID_ACTIVIDAD, -1);
                    if (descripcionAct !== null && elem !== null) {
                        descripcionAct.style.top = "calc(2rem + " + elem.offsetHeight + "px)";
                        /*if(elem.classList.contains("mostrarActividad")){
                            //descripcionAct.style.height = 0;
                            new Promise(resolve => setTimeout(resolve, 1000)).then(() => { 
                                descripcionAct.classList.remove("bordeTablaActividades");
                                localStorage.removeItem(process.env.REACT_APP_ID_ACTIVIDAD);
                            
                                });
                        }
                        else{
                            /*const altAct = elem.offsetHeight;
                            const tabla = document.getElementById("tabla");
                            const paginacion = document.getElementById("paginacion");
                            descripcionAct.classList.add("bordeTablaActividades");
                            new Promise(resolve => setTimeout(resolve, 1000)).then(() => { 
                                descripcionAct.style.height = "calc(" + (tabla.offsetHeight - paginacion.offsetHeight - altAct) + "px - 4rem)";
                                localStorage.setItem(process.env.REACT_APP_ID_ACTIVIDAD, idAct);
                            });* /
                        }
                         */
                        if (elem.classList.contains("mostrarActividad")) {

                            document.getElementById("scrollAreaActividades").classList.remove("overflow-hidden");
                            document.getElementById("scrollAreaActividades").classList.remove("marginScroll");
                            descripcionAct.style.height = 0;

                            for (var i = 1; i <= 4; i++) {
                                const reuniones = document.getElementById("reuniones" + i);
                                reuniones.classList.add("hide");
                                document.getElementById("titReunion" + i).classList.remove("show");
                            }
                            new Promise(resolve => setTimeout(resolve, 500)).then(() => {
                                document.getElementById("containerActividades").classList.remove("mostrar");
                                descripcionAct.classList.remove("bordeTablaActividades");
                                //document.getElementById("idAct" +idAct).style.top = topActActual;
                                elem.classList.remove("mostrarActividad");
                                const paginacion = document.getElementById("paginacion");
                                paginacion.classList.remove("ocultarElemento")
                                const botonBuscar = document.getElementById("botonBuscarCompleto");
                                document.getElementById("btnImprimir").classList.add("d-none")
                                botonBuscar.classList.remove("d-none")
                                paginaActual.forEach(function (elem) {
                                    if (idAct !== elem.eventoId) {
                                        const elem2 = document.getElementById("idAct" + elem.eventoId);
                                        elem2.classList.remove("ocultarActividad");
                                    }
                                });
                                new Promise(resolve => setTimeout(resolve, 500)).then(() => {
                                    localStorage.removeItem(process.env.REACT_APP_ID_ACTIVIDAD);
                                });
                                //localStorage.removeItem(process.env.REACT_APP_ID_ACTIVIDAD);
                            });


                        }
                        else {
                            document.getElementById("containerActividades").classList.add("mostrar");
                            document.getElementById("scrollAreaActividades").classList.add("overflow-hidden");
                            document.getElementById("scrollAreaActividades").classList.add("marginScroll");
                            document.getElementById("scrollAreaActividades").scroll(0, 0);
                            //setTopActActual(document.getElementById("idAct" +idAct).style.top );
                            cambiarEvento(idAct)
                            seleccionarIscripcion(idInscripcion);
                            //localStorage.setItem(process.env.REACT_APP_ID_ACTIVIDAD, idAct);
                            elem.classList.add("mostrarActividad");
                            paginaActual.forEach(function (elem) {
                                if (elem.eventoId !== idAct) {
                                    const elem2 = document.getElementById("idAct" + elem.eventoId);
                                    elem2.classList.add("ocultarActividad");
                                }
                            });
                            const altAct = elem.offsetHeight;
                            const tabla = document.getElementById("tabla");
                            const paginacion = document.getElementById("paginacion");
                            document.getElementById("botonBuscarCompleto").classList.add("d-none");
                            document.getElementById("btnImprimir").classList.remove("d-none")
                            paginacion.classList.add("ocultarElemento");
                            new Promise(resolve => setTimeout(resolve, 500)).then(() => {
                                descripcionAct.classList.add("bordeTablaActividades");
                                descripcionAct.style.height = "calc(" + (tabla.offsetHeight - altAct) + "px - 4rem)";//- paginacion.offsetHeight

                                //localStorage.setItem(process.env.REACT_APP_ID_ACTIVIDAD, idAct);
                                new Promise(resolve => setTimeout(resolve, 500)).then(() => {
                                    localStorage.setItem(process.env.REACT_APP_ID_ACTIVIDAD, idAct);
                                });
                            });

                        }
                    }
                }
            }
        }
    }

    function mostrarReuniones(tipoReunion) {
        const elem = document.getElementById("titReunion" + tipoReunion);
        const reuniones = document.getElementById("reuniones" + tipoReunion);
        if (elem.classList.contains("show")) {
            elem.classList.remove("show");
            reuniones.classList.add("hide");
        }
        else {
            /*const reuniones = document.getElementById("reuniones" + tipoReunion);
            reuniones.style.height = reuniones.scrollHeight + "px";*/
            elem.classList.add("show");
            reuniones.classList.remove("hide");

        }
    }

    function editarInscripcion(inscripcion) {
        noDesplegarActividad();
        setInscripcionModificar(inscripcion);
        setPermitirElegirHorario(inscripcion.permitirElegirHorario)
    }

    function getParams(elem, tipoModif) {
        var params;
        if (tipoModif === 0)
            params = elem.empresasDeInteres;
        else if (tipoModif === 1)
            params = elem.empresasInteresadas;
        return params;
    }

    function cambiarActividad(idInscripcion, idEmpresa, idReunion, tipoModif) {
        //tipoModif -- 0 = cancelarInvitacion, 1 = aceptar invitación, 2 = cancelarReunion, 3 = reintentarReunion

        if (tipoModif === 0) {
            var params = eventoActual;
            params.empresasDeInteres = eventoActual.empresasDeInteres.filter(item => item.id.localeCompare(idEmpresa) !== 0);
            setEventoActual((params) => {
                return { ...params, ...params };
            });
            setElementosTotal(elementosTotal.map((elem) => {
                if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                    elem.empresasDeInteres = elem.empresasDeInteres.filter(item => item.id.localeCompare(idEmpresa) !== 0);
                return elem;
            }));

            setPaginaActual(paginaActual.map((elem) => {
                if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                    elem.empresasDeInteres = elem.empresasDeInteres.filter(item => item.id.localeCompare(idEmpresa) !== 0);
                return elem;
            }));

            setElementos(elementos.map((elem) => {
                var ret = elem.map((elem2) => {
                    if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem2.empresasDeInteres = elem2.empresasDeInteres.filter(item => item.id.localeCompare(idEmpresa) !== 0);
                    return elem2;
                })
                return ret;
            }));


            setElementosCopia(elementosCopia.map((elem) => {

                var ret = elem.map((elem2) => {
                    if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem2.empresasDeInteres = elem2.empresasDeInteres.filter(item => item.id.localeCompare(idEmpresa) !== 0);
                    return elem2;
                })
                return ret;
            }));
        } else if (tipoModif === 1 || tipoModif === 3) {

            var params = {
                params: {
                    inscripcionId: idInscripcion
                }
            }
            axios
                .get(process.env.REACT_APP_URL + 'empresa/informacionEmpresa', params)
                .then(function (response) {
                    setEventoActual(response.data)
                    setElementosTotal(elementosTotal.map((elem) => {
                        if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                            elem = response.data;
                        return elem;
                    }));

                    setPaginaActual(paginaActual.map((elem) => {
                        if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                            elem = response.data;
                        return elem;
                    }));

                    /*setElementos(elementos.map((elem) => {
                        if (elem.inscripcionId.localeCompare(idInscripcion) ===0) 
                            elem = response.data;
                        return elem;
                    }));*/
                    setElementos(elementos.map((elem) => {
                        var ret = elem.map((elem2) => {
                            if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                                elem2 = response.data;
                            return elem2;
                        })
                        return ret;
                    }));

                    setElementosCopia(elementosCopia.map((elem) => {

                        var ret = elem.map((elem2) => {
                            if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                                elem2 = response.data;
                            return elem2;
                        })
                        return ret;
                    }));
                    /*
                    setElementosCopia(elementosCopia.map((elem) => {
                        if (elem.inscripcionId.localeCompare(idInscripcion) ===0) 
                            elem = response.data;
                        return elem;
                    }));*/
                })
                .catch(function (error) {
                    toastError(handleError(error))
                    //return toast.error("Error al cargar las redacciones, inténtelo más tarde");
                });
        } else if (tipoModif === 2) {

            var params = eventoActual;
            var empresaInteresada = eventoActual.reuniones.filter(item => item.id.localeCompare(idReunion) === 0)[0].empresa;
            params.empresasInteresadas.push(empresaInteresada);
            params.reuniones = params.reuniones.filter(item => item.id.localeCompare(idReunion) !== 0);

            setEventoActual((params) => {
                return { ...params, ...params };
            });
            setElementosTotal(elementosTotal.map((elem) => {
                if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                    elem.reuniones = elem.reuniones.filter(item => item.id.localeCompare(idReunion) !== 0);
                return elem;
            }));


            setPaginaActual(paginaActual.map((elem) => {
                if (elem.inscripcionId.localeCompare(idInscripcion) === 0)
                    elem.reuniones = elem.reuniones.filter(item => item.id.localeCompare(idReunion) !== 0);
                return elem;
            }));
            setElementos(elementos.map((elem) => {

                var ret = elem.map((elem2) => {
                    if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem2.reuniones = elem2.reuniones.filter(item => item.id.localeCompare(idReunion) !== 0);
                    return elem2;
                })
                return ret;
            }));


            setElementosCopia(elementosCopia.map((elem) => {

                var ret = elem.map((elem2) => {
                    if (elem2.inscripcionId.localeCompare(idInscripcion) === 0)
                        elem2.reuniones = elem2.reuniones.filter(item => item.id.localeCompare(idReunion) !== 0);
                    return elem2;
                })
                return ret;
            }));
        }

    }

    useEffect(() => {
        document.getElementById("buscarText").addEventListener("keyup", function () {
            filtrarNombre();
        });
    }, [elementosTotal])

    function filtrarNombre() {
        const idAct = localStorage.getItem(process.env.REACT_APP_ID_ACTIVIDAD);
        if (idAct !== null) {// && parseInt(localStorage.getItem(process.env.REACT_APP_FILTRADO)) === 1
            mostrarActividad(idAct);
        }
        const filtro = document.getElementById("buscarText").value;
        if (filtro.localeCompare("") !== 0) {
            localStorage.setItem(process.env.REACT_APP_FILTRADO, 1);
            let elemPagina = [];
            var contPaginas = 0;
            var contElem = 0;
            var elemActFaltan = true;
            setElementos([])
            elementosTotal.map(function (elem) {
                if (elem.nombreEvento.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                    .includes(filtro.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))) {
                    elemPagina.push(elem);
                    contElem++;
                    if ((contElem) % Math.floor(cantidadElementos) === 0) {
                        var objeto = elemPagina;
                        setElementos(elementos => [...elementos, objeto])
                        if (elemActFaltan) {
                            setPaginaActual(objeto);
                            elemActFaltan = false;
                        }
                        elemPagina = [];
                        contPaginas++;
                    }
                }
            });
            if (elemPagina.length !== 0) {
                var objeto = elemPagina;
                setElementos(elementos => [...elementos, objeto])
                if (elemActFaltan) {
                    setPaginaActual(objeto);
                    elemActFaltan = false;
                }
                contPaginas++;
            }
            if (elemActFaltan) {
                setPaginaActual([]);
            }
            if (contPaginas === 0)
                contPaginas++;
            setCantPaginas(contPaginas);
        }
        else {
            quitarFiltro()
        }
    }
    function esMobile() {
        return window.screen.availWidth <= 575;
    }

    function esActividadPantGrande() {
        return window.screen.availWidth <= 720 && window.screen.availHeight >= 901;
    }
    function quitarFiltro() {
        //if(parseInt(localStorage.getItem(process.env.REACT_APP_FILTRADO)) === 1){
        setPrimeraCarga(true);
        setElementos(elementosCopia);
        setCantPaginas(cantPaginasCopia);

        localStorage.removeItem(process.env.REACT_APP_FILTRADO);//}
    }

    function reintentar(reunionId, inscripcionId) {
        const idInscripcion = localStorage.getItem(process.env.REACT_APP_INSCRIPCION);
        const params = {
            params: {
                reunionId: reunionId,
                inscripcionId: inscripcionId
            }
        }
        axios
            .post(process.env.REACT_APP_URL + 'inscripcion/crearReunion', null, params)
            .then((res) => {
                cambiarActividad(idInscripcion, -1, -1, 3);
                toastSuccess("Reunión creada")
            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }

    function cancelarInvitacion(idEmpresa) {
        const idInscripcion = localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION);
        const params = {
            params: {
                idInscripcion: idInscripcion,
                idEmpresa: idEmpresa
            }
        }
        axios
            .post(process.env.REACT_APP_URL + 'inscripcion/eliminarEmpresaInteres', null, params)
            .then((res) => {
                //document.getElementById("btnInvitacionEnv" + idEmpresa).classList.add("btnDisabled");
                //document.getElementById("btnInvitacionEnv" + idEmpresa).innerText = "Invitación cancelada";
                cambiarActividad(idInscripcion, idEmpresa, -1, 0);
                toastSuccess("Invitación Cancelada")
            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }

    function agregarModificado(idElem) {
        setIdsCancelada(idsCancelada => [...idsCancelada, idElem]);
    }

    function aceptarInvitacion(idEmpresa) {
        const idInscripcion = localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION);
        const params = {
            params: {
                idInscripcion: idInscripcion,
                idEmpresa: idEmpresa
            }
        }
        axios
            .post(process.env.REACT_APP_URL + 'inscripcion/agregarEmpresaInteres', null, params)
            .then((res) => {
                //document.getElementById("btnInvitacionRec" + idEmpresa).classList.add("btnDisabled");
                //document.getElementById("btnInvitacionRec" + idEmpresa).innerText = "Invitación aceptada";
                cambiarActividad(idInscripcion, idEmpresa, -1, 1);
                toastSuccess("Reunión creada");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }


    function seleccionarIscripcion(idInscripcion) {
        localStorage.setItem(process.env.REACT_APP_ID_INSCRIPCION, idInscripcion);
    }

    function fechaEsMayor(fecha) {
        var fechaN = fecha.split("/");
        const d = new Date(fechaN[2], fechaN[1] - 1, fechaN[0]);
        d.getDate();
        return d.getTime() > Date.now();
    }

    function inscripcionCancelada(idElem) {
        var ret = false;
        idsCancelada.map(function (id) {
            if (id.localeCompare(idElem) === 0) {
                ret = true;
            }
        });
        return ret;
    }

    function noDesplegarActividad() {
        localStorage.setItem(process.env.REACT_APP_ES_CANCELAR, 1)
    }
    return (
        <>

            <div className='container-fluid text-white textoTablas tabla px-0' id='tabla'>

                {loading ?
                    <LoaderTabla white/>
                    :
                    <div className='position-relative h-100'>
                        <div id="scrollAreaActividades" className='alturaScrollTablaActividades scrollBarBlanca position-relative  scrollArea px-3 px-sm-0 '>
                            {paginaActual.length !== 0 ?

                                paginaActual.map(function (elem) {
                                    return (
                                        <div id={"idAct" + elem.eventoId} className='row py-3 pe-3 px-3 bordeTablaActividades 
                                align-items-center rounded-3 actividad pe-0 position-absolute'
                                            onClick={elem.permiteReuniones ? () => mostrarActividad(elem.eventoId, elem.inscripcionId) : () => mostrarActividad(elem.eventoId, elem.inscripcionId, false)}>{/*start-0 end-0*/}

                                            <div className='col-sm col-12 tituloActividad position-relative pb-2 pb-sm-0'>
                                                {elem.nombreEvento}
                                                {elem.permiteReuniones ?
                                                    <img className='mx-3 flechaDropdown mostrarMobile d-none flechaDropMobile' src={flechaSelect} alt="" />
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </div>
                                            <div className='col text-center pt-3 pt-sm-0'>
                                                {elem.fechaEvento}
                                            </div>
                                            <div className='col text-center pt-3 pt-sm-0'>
                                                {elem.inscripcionHoraInicio + " / " + elem.inscripcionHoraFin}
                                            </div>

                                            <div className='col-5  text-sm-end text-center  pe-sm-0 w-fit-content-1200 pt-4 pt-sm-0 col-12-mobile'>



                                                {elem.permiteReuniones ?
                                                    <>
                                                        {esMobile() || esActividadPantGrande() ?
                                                            <button class="btn  btn-outline-secondary bold-botones me-5 btn-cuadrado anchoBtnActividad " > {/*d-none d-inline-block-mobile*/}
                                                                <div className='btn-ver-mas'>Ver Más</div><div className='d-none btn-cerrar-actividad'>Cerrar</div>
                                                            </button>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            fechaEsMayor(elem.fechaEvento) && !inscripcionCancelada(elem.inscripcionId) ?
                                                                <button id={'btnEditInscripcion' + elem.inscripcionId} class="btn btn-outline-secondary bold-botones mx-sm-3 me-3 ocultarBotonesActividad btn-cuadrado"
                                                                    type="submit" onClick={() => editarInscripcion(elem)} data-bs-toggle="modal"
                                                                    data-bs-target="#staticBackdrop" >Editar</button>
                                                                :
                                                                <button id={'btnEditInscripcion' + elem.inscripcionId} class="btn btn-outline-secondary  btnDisabled bold-botones mx-sm-3 me-3 ocultarBotonesActividad btn-cuadrado"
                                                                    type="submit">Editar</button>} </>
                                                    :
                                                    <></>
                                                }
                                                {fechaEsMayor(elem.fechaEvento) ?
                                                    !inscripcionCancelada(elem.inscripcionId) ?
                                                        <button id={'btnInscripcion' + elem.inscripcionId} class={"btn btn-outline-secondary bold-botones mx-sm-3 btn-cuadrado" + (elem.permiteReuniones || (!esMobile() && !esActividadPantGrande()) ? " ocultarBotonesActividad  ms-3 " : "")}
                                                            type="submit" onClick={noDesplegarActividad} data-bs-toggle="modal"
                                                            data-bs-target="#cancelarInscripcion" >Cancelar Inscripción</button>
                                                        :
                                                        <button id={'btnInscripcion' + elem.inscripcionId} class={"btn btn-outline-secondary  btnDisabled bold-botones mx-sm-3 btn-cuadrado" + (elem.permiteReuniones || (!esMobile() && !esActividadPantGrande()) ? " ocultarBotonesActividad  ms-3 " : "")}
                                                            type="submit">Inscripción cancelada</button>
                                                    :
                                                    <button id={'btnInscripcion' + elem.inscripcionId} class={"btn btn-outline-secondary btnDisabled bold-botones mx-sm-3 btn-cuadrado" + (elem.permiteReuniones || (!esMobile() && !esActividadPantGrande()) ? " ocultarBotonesActividad  ms-3 " : "")}
                                                        type="submit"  >Cancelar Inscripción</button>
                                                }
                                                {elem.permiteReuniones || (!esMobile() && !esActividadPantGrande()) ?
                                                    <li class="dropdown ms-sm-2 d-none mostrarConfigActividad " onClick={noDesplegarActividad} >

                                                        <button class="btn btn-outline-secondary bold-botones mx-sm-3 btn-cuadrado anchoBtnActividad"
                                                            data-bs-toggle="dropdown" aria-expanded="false" >Editar</button>

                                                        <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil">
                                                            <li>
                                                                {/*<button class="btn colorPrincipal text-white me-3 bold-botones btn-cuadrado" 
                                                    >Editar</button>
                                                
                                                    <button  class="btn colorPrincipal text-white bold-botones btn-cuadrado " 
                                                    data-bs-toggle="modal" data-bs-target="#modalCodigo">Cancelar Inscripción</button>*/}
                                                                {elem.permiteReuniones ?
                                                                    fechaEsMayor(elem.fechaEvento) && !inscripcionCancelada(elem.inscripcionId) ?
                                                                        <button id={'btnEditInscripcion' + elem.inscripcionId} class="btn colorPrincipal text-white me-3 bold-botones btn-cuadrado"
                                                                            type="submit" onClick={() => editarInscripcion(elem)} data-bs-toggle="modal"
                                                                            data-bs-target="#staticBackdrop" >Editar</button>
                                                                        :
                                                                        <button id={'btnEditInscripcion' + elem.inscripcionId} class="btn colorPrincipal text-white me-3 bold-botones btn-cuadrado  btnDisabled "
                                                                            type="submit">Editar</button>
                                                                    :
                                                                    <></>
                                                                }

                                                                {fechaEsMayor(elem.fechaEvento) ?
                                                                    !inscripcionCancelada(elem.inscripcionId) ?
                                                                        <button id={'btnInscripcion' + elem.inscripcionId} class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                            type="submit" onClick={noDesplegarActividad} data-bs-toggle="modal"
                                                                            data-bs-target="#cancelarInscripcion" >Cancelar Inscripción</button>
                                                                        :
                                                                        <button id={'btnInscripcion' + elem.inscripcionId} class="btn colorPrincipal text-white bold-botones btn-cuadrado  btnDisabled "
                                                                            type="submit">Inscripción cancelada</button>
                                                                    :
                                                                    <button id={'btnInscripcion' + elem.inscripcionId} class="btn colorPrincipal text-white bold-botones btn-cuadrado  btnDisabled "
                                                                        type="submit"  >Cancelar Inscripción</button>
                                                                }
                                                                <div className="cruzMenuConfiguracion" alt="" />
                                                            </li>

                                                        </ul>
                                                    </li>
                                                    :
                                                    <></>
                                                }
                                                {elem.permiteReuniones ?
                                                    <img className='mx-3 flechaDropdown ocultarMobile' src={flechaSelect} alt="" />
                                                    :
                                                    <>
                                                        <div className='mx-3 espacioFlecha d-inline-block ocultarMobile' />
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <>
                                    <p className='text-center pt-4'>No se encontraron actividades</p>
                                </>
                            }
                        </div>
                        <div id="descripcionAct" className='row descripcionActividad rounded-3 position-absolute '>{/*start-0 end-0*/}
                            <div className="container anchoTablaActividades py-4">
                                <div id='titReunion1' className={'row py-1 mb-2 align-items-center tituloDescripcionActividad rounded-2'
                                    + (eventoActual.mostrarReuniones ? '' : ' d-none')} onClick={() => mostrarReuniones(1)}>
                                    <div className='col-10 centrarContainer'>
                                        Aceptadas<img className='mx-3' src={aceptadas} alt="" />
                                    </div>

                                    <div className='col  centrarContainer'>
                                        <img className='flechaTitReunion' src={flechaSelect} alt="" />
                                    </div>
                                </div>

                                <div id="reuniones1" className={'reuniones hide' + (eventoActual.mostrarReuniones ? '' : ' d-none')}>
                                    {eventoActual.reuniones.length !== 0 ?
                                        eventoActual.reuniones.map(function (elem, i) {
                                            /*return(                           
                                                <div className='row py-2 px-3 text-center align-items-center'>
                                                    <div className='col'>
                                                        {elem.empresa.nombre}
                                                    </div>
                                                    <div className='col'>
                                                        {"Mesa: " + elem.numeroMesa}
                                                    </div>
                                                    <div className='col'>
                                                        {elem.representante.apellido + ", " + elem.representante.nombre}
                                                    </div>
                                                    <div className='col'>
                                                        {elem.horaInicio + " / " + elem.horaFin}
                                                    </div>
                                                    <div className='col'>
                                                        {fechaEsMayor(eventoActual.fechaEvento) && !inscripcionCancelada(eventoActual.inscripcionId)?
                                                            <button id={"btnReunion" + elem.id} class="btn btn-outline-secondary bold-botones" 
                                                            type="submit" onClick={()=>cancelarReunion(elem.id, elem.empresa.id)}>Cancelar Reunión</button>  
                                                        :
                                                            <button id={"btnReunion" + elem.id} class="btn btn-outline-secondary bold-botones btnDisabled" 
                                                            type="submit">Cancelar Reunión</button>
                                                        }
                                                    </div>
                                                </div>                           
                                            )*/
                                            return (
                                                <div className='py-2'>
                                                    <div className='row py-3 px-3 mx-0 mx-sm-5 text-center align-items-center reunion rounded-4'>
                                                        <div className='col-12 tituloReunion pb-2'>
                                                            {elem.empresa.nombre}
                                                        </div>
                                                        <div className='col-12 pt-3 px-500-0'>
                                                            <div className='mx-3 d-inline-block pb-2 pb-sm-3'>{"Mesa: " + elem.numeroMesa}</div>

                                                            <div className='mx-3 d-inline-block pb-2 pb-sm-3'>
                                                                {"Horario: " + elem.horaInicio + " / " + elem.horaFin}
                                                            </div>
                                                            <div className='mx-3 d-inline-block pb-2 pb-sm-3'>
                                                                {"Representante: " + elem.representante.apellido + ", " + elem.representante.nombre}
                                                            </div>
                                                            <div className='mx-3 d-inline-block pb-3'>
                                                                {"Cargo: " + elem.representante.cargo}
                                                            </div>
                                                        </div>
                                                        <div className='col-12 px-500-0'>
                                                            <button class="btn btn-outline-secondary bold-botones me-4 btn-cuadrado btn-act-perfil" data-bs-toggle="modal"
                                                                data-bs-target="#modalPerfil" onClick={() => setPerfil(elem.empresa)}> Ver Perfil</button>
                                                            {fechaEsMayor(eventoActual.fechaEvento) && !inscripcionCancelada(eventoActual.inscripcionId) ?
                                                                <button id={"btnReunion" + elem.id} class="btn btn-outline-secondary bold-botones btn-cuadrado"
                                                                    type="submit" onClick={() => setParamsCancReunion({ idReunion: elem.id, idEmpresa: elem.empresa.id })} data-bs-toggle="modal"
                                                                    data-bs-target="#cancelarReunion">Cancelar Reunión</button>
                                                                :
                                                                <button id={"btnReunion" + elem.id} class="btn btn-outline-secondary bold-botones btnDisabled btn-cuadrado"
                                                                    type="submit">Cancelar Reunión</button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <p className='text-center mb-0 pb-3'>No se encontraron reuniones</p>
                                    }
                                </div>
                                <div id='titReunion2' className={'row py-1 my-2 align-items-center tituloDescripcionActividad rounded-2' +
                                    (eventoActual.mostrarReuniones && !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')} onClick={() => mostrarReuniones(2)}>
                                    <div className='col-10 centrarContainer'>
                                        Recibidas<img className='mx-3' src={recibidas} alt="" />
                                    </div>
                                    <div className='col  centrarContainer'>
                                        <img className='flechaTitReunion' src={flechaSelect} alt="" />
                                    </div>
                                </div>
                                <div id="reuniones2" className={'reuniones hide' + (eventoActual.mostrarReuniones && !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')}>
                                    {eventoActual.empresasInteresadas.length !== 0 ?
                                        eventoActual.empresasInteresadas.map(function (elem, i) {
                                            return (
                                                <div className='row py-2 px-3 text-center align-items-center'>
                                                    <div className='col'>
                                                        {elem.nombre}
                                                    </div>
                                                    <div className='col'>
                                                        {fechaEsMayor(eventoActual.fechaEvento) && !inscripcionCancelada(eventoActual.inscripcionId) ?
                                                            <button id={"btnInvitacionRec" + elem.id} class="btn btn-outline-secondary bold-botones"
                                                                type="submit" onClick={() => aceptarInvitacion(elem.id)}>Aceptar invitación</button>
                                                            :
                                                            <button id={"btnInvitacionRec" + elem.id} class="btn btn-outline-secondary bold-botones btnDisabled"
                                                                type="submit">Aceptar invitación</button>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <p className='text-center mb-0 pb-3'>No se encontraron invitaciones recibidas</p>
                                    }
                                </div>
                                <div id='titReunion3' className={'row py-1 my-2 align-items-center tituloDescripcionActividad rounded-2' + (!eventoActual.mostrarReuniones || !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')}
                                    onClick={() => mostrarReuniones(3)}>
                                    <div className='col-10 centrarContainer'>
                                        Enviadas<img className='mx-3 flechaDropdown' src={enviadas} alt="" />
                                    </div>

                                    <div className='col  centrarContainer'>
                                        <img className='flechaTitReunion' src={flechaSelect} alt="" />
                                    </div>
                                </div>
                                <div id="reuniones3" className={'reuniones hide' + (!eventoActual.mostrarReuniones || !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')}>
                                    {eventoActual.empresasDeInteres.length !== 0 ?
                                        eventoActual.empresasDeInteres.map(function (elem, i) {
                                            return (
                                                <div className='row py-2 px-3 text-center align-items-center'>
                                                    <div className='col'>
                                                        {elem.nombre}
                                                    </div>
                                                    <div className='col'>
                                                        {fechaEsMayor(eventoActual.fechaEvento) && !inscripcionCancelada(eventoActual.inscripcionId) ?
                                                            <button id={"btnInvitacionEnv" + elem.id} class="btn btn-outline-secondary bold-botones"
                                                                type="submit" onClick={() => cancelarInvitacion(elem.id)}>Cancelar invitación</button>
                                                            :
                                                            <button id={"btnInvitacionEnv" + elem.id} class="btn btn-outline-secondary bold-botones btnDisabled"
                                                                type="submit">Cancelar invitación</button>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <p className='text-center  mb-0 pb-3'>No se encontraron invitaciones enviadas</p>
                                    }
                                </div>
                                <div id='titReunion4' className={'row py-1 my-2 align-items-center tituloDescripcionActividad rounded-2'
                                    + (eventoActual.mostrarReuniones && !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')} onClick={() => mostrarReuniones(4)}>
                                    <div className='col-10 centrarContainer'>
                                        No Concretadas<img className='mx-3 flechaDropdown' src={noConcretadas} alt="" />
                                    </div>

                                    <div className='col  centrarContainer'>
                                        <img className='flechaTitReunion' src={flechaSelect} alt="" />
                                    </div>
                                </div>
                                <div id="reuniones4" className={'reuniones hide' + (eventoActual.mostrarReuniones && !eventoActual.mostrarSoloConcretadas ? '' : ' d-none')}>
                                    {eventoActual.reunionesNoConcretadas.length !== 0 ?
                                        eventoActual.reunionesNoConcretadas.map(function (elem, i) {
                                            return (
                                                <div className='row py-2 px-3 text-center align-items-center'>
                                                    <div className='col'>
                                                        {elem.nombreEmpresa}
                                                    </div>
                                                    <div className='col'>
                                                        {fechaEsMayor(eventoActual.fechaEvento) && !inscripcionCancelada(eventoActual.inscripcionId) ?
                                                            <button id={"btnInvitacionEnv" + elem.reunionId} class="btn btn-outline-secondary bold-botones"
                                                                type="submit" onClick={() => reintentar(elem.reunionId, eventoActual.inscripcionId)}>Reintentar</button>
                                                            :
                                                            <button id={"btnInvitacionEnv" + elem.reunionId} class="btn btn-outline-secondary bold-botones btnDisabled"
                                                                type="submit">Reintentar</button>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <p className='text-center  mb-0 pb-3'>No se encontraron invitaciones enviadas</p>
                                    }
                                </div>
                            </div>
                        </div>

                        <Paginacion isTablaActividades cambiarPagina={cambiarPagina} cantPaginas={cantPaginas} pagActual={pagActual} setPagActual={setPagActual} />
                    </div>
                }
            </div>
            <ModalPerfil perfil={perfil} esReunion={true} />
            <Modal inscripcionModificar={inscripcionModificar} esModificar={true} modificarInscripcion={modificarInscripcion}
                permitirElegirHorario={permitirElegirHorario} />
            <DeseaCancelar agregarModificado={agregarModificado} id={'cancelarInscripcion'} />
            <DeseaCancelar cambiarActividad={cambiarActividad} id={'cancelarReunion'} params={paramsCancReunion} />
            <Imprimir eventoActual={eventoActual} />
        </>
    );
}


export default TablaActividades;